import { Icon } from '@chakra-ui/react';
import { FaTrashAlt } from 'react-icons/fa';
import React from 'react';

function TrashIcon() {
  return <Icon as={FaTrashAlt} color="white.500" />;
}

export default TrashIcon;
